var React = require('react');

function ArrowDropdown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.083 8.952l4.427-5.73A2 2 0 0010.927 0H2.073A2 2 0 00.49 3.223l4.427 5.729a2 2 0 003.166 0z","fill":"currentColor","fillRule":"evenodd"}));
}

ArrowDropdown.defaultProps = {"width":"13px","height":"10px","viewBox":"0 0 13 10"};

module.exports = ArrowDropdown;

ArrowDropdown.default = ArrowDropdown;
